<h1 class="text-secondary text-sm px-3 pt-4">
  Gérez les clés API permettant à
  <strong>{{ supplierLabel }}</strong>
  d'accéder à l'application.
</h1>

<div class="mt-6 flex flex-col md:flex-row md:items-start">
  <div class="flex-auto">
    <div class="card mt-6">
      <base-data-table-header
        label="Clés API"
        [loading]="loadingData"
        [showArchives]="false"
        [showSearch]="false"
        [createPermission]="ENUM_PERMISSION.MANAGE_SUPPLIER_API_KEY"
        [backgroundColorWhite]="true"
        (onCreate)="openCreateModal()"
      ></base-data-table-header>

      <div *ngIf="!loadingData && dataSource.data.length === 0" class="text-center py-12 text-secondary">
        <mat-icon style="font-size: 60px; width: 60px; height: 60px">vpn_key</mat-icon>
        <p class="mt-4">Aucune clé API générée pour ce fournisseur.</p>
      </div>

      <base-data-table
        *ngIf="dataSource.data.length > 0"
        [count]="count"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        (onPageEvent)="pageEvent($event)"
        (onSortEvent)="onSortEvent($event)"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [feisColumns]="feisColumns"
        [showPaginator]="false"
        [showSort]="true"
        [actionsTemplate]="revokeActionTpl"
        [customColumnTemplate]="statutTpl"
      ></base-data-table>
    </div>
  </div>
</div>

<ng-template #statutTpl let-column let-element="element">
  <span
    *ngIf="!isRevoked(element)"
    class="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800"
  >
    Active
  </span>
  <span
    *ngIf="isRevoked(element)"
    class="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-red-100 text-red-800"
    [matTooltip]="
      'Révoquée le ' +
      (element.revokedAt | date: 'dd/MM/yyyy') +
      ' par ' +
      element.revokedBy?.firstName +
      ' ' +
      element.revokedBy?.lastName
    "
  >
    Révoquée
  </span>
</ng-template>

<ng-template #revokeActionTpl let-element="value">
  <button
    *ngIf="element"
    mat-menu-item
    [permissionBlock]="[ENUM_PERMISSION.MANAGE_SUPPLIER_API_KEY]"
    (click)="revokeKey(element)"
    [disabled]="isRevoked(element)"
  >
    <mat-icon>block</mat-icon>
    <span>Révoquer</span>
  </button>
</ng-template>
